/**
 * @Description 区域保护详情
 */
import { FC } from 'react';
import V2Drawer from '../../Feedback/V2Drawer';
import AreaProtection from '.';
const AreaProtectionDrawer:FC<any> = ({
  id,
  open,
  setOpen,
  updateHandle,
  approvalId, // 是否进入审批状态
}) => {
  return <V2Drawer
    open={open}
    onClose={() => setOpen(false)}
    destroyOnClose
  >
    <AreaProtection
      id={id}
      open={open}
      setOpen={setOpen}
      onComplete={updateHandle}
      approvalId={approvalId} // 是否进入审批状态
    />
  </V2Drawer>;
};
export default AreaProtectionDrawer;
